class WorkbookTabConfig {
    hiddenTab: KnockoutObservable<boolean>;
    backgroundColor: KnockoutObservable<string>;
    fontColor: KnockoutObservable<string>;

    constructor(data, workbookTab: WorkbookTab) {
        this.hiddenTab = ko.observable(data.hiddenTab);
        this.backgroundColor = ko.observable(data.backgroundColor ?? "");
        this.fontColor = ko.observable(data.fontColor ?? "");

        let saveConfig = function (this: WorkbookTab) { this.saveTabConfig() }.bind(workbookTab);
        this.fontColor.subscribe(saveConfig);
        this.backgroundColor.subscribe(saveConfig);
    }
}